import { useTranslation } from 'react-i18next';
import NewFormCard, { FormCardContainer } from 'views/declarations/common/cards/NewFormCard';
import useHideEntities from '../../../../../../hooks/useHideEntities';
import TaricCodesBlock, {
    taricCodesBlockValidation,
    taricCodesRequiredBlockValidation,
} from '../../../import/blocks/TaricCodesBlock';
import CombinedNomenclatureCodeBlock, {
    combinedNomenclatureCodesBlockValidation as combinedNomenclatureCodeBlockValidation,
} from '../../blocks/CombinedNomenclatureCodeBlock';
import CommodityCusCodeBlock, { commodityCusCodeBlockValidation } from '../../blocks/CommodityCusCodeBlock';
import NationalAdditionalCodesBlock, {
    nationalAdditionalCodesBlockValidation,
} from '../../blocks/NationalAdditionalCodesBlock';
import TaricAdditionalCodesBlock, { taricAdditionalCodesBlockValidation } from '../../blocks/TaricAdditionalCodesBlock';

export const commodityCodesCardValidation = {
    selfValidators: [
        commodityCusCodeBlockValidation,
        combinedNomenclatureCodeBlockValidation,
        taricAdditionalCodesBlockValidation,
        nationalAdditionalCodesBlockValidation,
    ],
};

export const cdsImportCommodityCodesCardValidation = {
    selfValidators: [
        commodityCusCodeBlockValidation,
        combinedNomenclatureCodeBlockValidation,
        taricCodesBlockValidation,
        taricAdditionalCodesBlockValidation,
        nationalAdditionalCodesBlockValidation,
    ],
};
export const cdsImportCommodityCodesCardRequiredValidation = {
    selfValidators: [
        commodityCusCodeBlockValidation,
        combinedNomenclatureCodeBlockValidation,
        taricCodesRequiredBlockValidation,
        taricAdditionalCodesBlockValidation,
        nationalAdditionalCodesBlockValidation,
    ],
};

const CommodityCodesCard = () => {
    const { t } = useTranslation('form');
    const { isFormType } = useHideEntities();

    return (
        <NewFormCard title={t('commodityCodes')}>
            <FormCardContainer>
                <CommodityCusCodeBlock />
                <CombinedNomenclatureCodeBlock />
                <TaricCodesBlock
                    hide={isFormType(['EXPORT_B1'])}
                    declarationOptions={{ UK_IMPORT_H1: { fieldOptions: { id: { required: true } } } }}
                />
                <TaricAdditionalCodesBlock />
                <NationalAdditionalCodesBlock />
            </FormCardContainer>
        </NewFormCard>
    );
};

export default CommodityCodesCard;
